<div class="background-primary">
    <div class="container listing-wrapper">
        <div class="row">
            <div class="col-lg-5 order-md-2">
                <ng-container *ngIf="parking">
                    <div class="card my-3 p-4 shadow corner-radius request-card" [ngClass]="{ 'show-request': showSendRequest }">
                        <div class="row">
                            <div class="col-12">
                                <button *ngIf="showSendRequest" class="d-lg-none d-inline-block icon-button" (click)="toggleSendRequest()">
                                    <i class="fa fa-times"></i>
                                </button>

                                <h3 *ngIf="parking.title">{{ parking.title }}</h3>
                                <h3 *ngIf="!parking.title">Unnamed Parking</h3>
                            </div>
                        </div>

                        <div class="row my-3">
                            <div class="col-12">
                                <div class="divider"></div>
                            </div>
                        </div>

                        <div *ngIf="accessDenied" class="alert alert-danger">
                            <h4>This is a private facility. You don't have access to park here.</h4>
                            <p>If you think this is an error. The please contact your parking manager.</p>
                        </div>

                        <form [formGroup]="formData" (submit)="createBooking($event)" autocomplete="off" novalidate *ngIf="!accessDenied">
                            <div class="container-fluid px-0">
                                <div class="row mt-3">
                                    <div class="form-group col-6">
                                        <label class="required">Choose a date</label>
                                        <input
                                            type="date"
                                            class="form-control"
                                            id="startDate"
                                            [attr.min]="bookingMinDate"
                                            [attr.max]="bookingMaxDate"
                                            name="startDate"
                                            formControlName="startDate"
                                            (change)="onDayChanged()"
                                        />
                                    </div>

                                    <div class="form-group col-6" (click)="openImageModal(template)">
                                        <label class="required">Bay Number</label>
                                        <input READONLY type="text" class="form-control" name="bayNumber" formControlName="bayNumber" placeholder="Click to select" />
                                    </div>
                                    <!--                                    <div class="form-group col-6">-->
                                    <!--                                        <a class="btn btn-info btn-sm mt-4"-->
                                    <!--                                           (click)="openImageModal(template)">-->
                                    <!--                                            Select Parking Bay-->
                                    <!--                                        </a>-->
                                    <!--                                    </div>-->
                                </div>

                                <div class="row mt-3">
                                    <div class="form-group col-12">
                                        <label class="required">Select Vehicle</label>
                                        <!--<div class="alert alert-success py-1"
                                             *ngIf="this.formData.value.occupants.length === this.formData.value.baysBooked">
                                            <small>Max vehicles selected</small>
                                        </div>-->

                                        <ng-select #dropDownListObject formControlName="occupants" [multiple]="true" [clearable]="false" [closeOnSelect]="true" required>
                                            <ng-template ng-header-tmp>
                                                <button (click)="openModalOccupant()" class="btn btn-sm btn-primary">Add vehicle</button>
                                            </ng-template>

                                            <ng-option *ngFor="let occupant of occupants" [value]="occupant.$key">{{ occupant.niceName() }}</ng-option>
                                        </ng-select>

                                        <div class="invalid-feedback" *ngIf="formData.get('occupants')?.hasError('required') && formData.get('occupants')?.touched">
                                            Selecting a vehicle is required.
                                        </div>
                                    </div>
                                </div>

                                <div class="row mt-3">
                                    <div class="form-group col-12 mt-3">
                                        <button [disabled]="!formData.valid || formLoading" type="submit" class="btn btn-primary w-100">
                                            <span *ngIf="formLoading" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                                            <span>Book this bay</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </ng-container>
                <div class="card my-3 p-4 shadow corner-radius" *ngIf="bookings && bookings[0]">
                    <h5>My Bookings</h5>

                    <table id="all-subscriptions" class="table table-hover table-sm">
                        <thead>
                            <tr>
                                <th scope="col">Booking Date</th>
                                <th scope="col">Bay Number</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let booking of bookings">
                                <td>
                                    <ng-container *ngIf="booking.startDate; else permanent">
                                        {{ booking.startDate | formatDate }}
                                    </ng-container>
                                    <ng-template #permanent>
                                        <span class="badge bg-warning"> Permanent </span>
                                    </ng-template>
                                </td>
                                <td>
                                    {{ booking.bayNumber }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="col-lg-7 order-md-1">
                <div *ngIf="parking" class="listing-container">
                    <div class="mb-4 position-relative">
                        <carousel *ngIf="images.length > 0" (activeSlideChange)="activeSlideChange($event)" [class]="'gallery-carousel'">
                            <slide *ngFor="let image of images; let i = index">
                                <img *ngIf="i <= highestIndex" [src]="image.smallUrl" class="w-100" />
                            </slide>
                        </carousel>
                        <div class="no-image-icon">
                            <i class="fa fa-image"></i>
                        </div>
                        <img src="/assets/images/parking/no_image.png" class="w-100" />
                        <div class="image-counter">
                            <small
                                ><strong>{{ currentImageIndex }} / {{ images.length }}</strong></small
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #popupOccupant class="modal fade" id="occupantSelectionModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">Add a vehicle</h5>
            <button (click)="closeModalOccupant()" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body p-0">
            <div class="container">
                <form #myForm="ngForm" [formGroup]="formDataOccupant" (ngSubmit)="createOccupant()">
                    <div class="row mt-2">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <label class="required">Make and Model</label>
                                <input formControlName="model" name="model" class="form-control" placeholder="City Golf" />
                            </div>
                        </div>
                    </div>
                    <div class="row mt-4">
                        <div class="form-group col-md-12">
                            <label class="required">Number Plate</label>
                            <input formControlName="numberPlate" name="numberPlate" class="form-control" />
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <label class="required">Vehicle Colour</label>
                                <input formControlName="colour" name="colour" class="form-control" placeholder="White" />
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <label>Primary Driver Name and Surname</label>
                                <input formControlName="fullName" name="fullName" class="form-control" placeholder="Name and Surname" />
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="form-group col-md-12">
                            <label>Optional description of the car</label>
                            <input formControlName="description" name="description" class="form-control" />
                        </div>
                    </div>
                    <div>
                        <div *ngIf="formError" class="col-12 mt-3">
                            <div class="form-group col-12 mt-3 alert alert-danger small" role="alert">
                                {{ formError }}
                            </div>
                        </div>
                    </div>
                    <div class="row my-5">
                        <div class="form-group col-sm-12">
                            <button class="btn btn-sm btn-primary float-end" type="submit" [disabled]="!formDataOccupant.valid || formLoadingOccupant == true">
                                <span *ngIf="formLoadingOccupant" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>

                                <i class="mdi mdi-gamepad-circle"></i> Add Vehicle
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #template>
    <div class="modal-header">
        <h5 class="modal-title">Select your bay</h5>
        <button type="button" class="btn-close" (click)="modalRef?.hide()"></button>
    </div>
    <div class="modal-body p-0 text-center">
        <svg
            [attr.viewBox]="'0 0 ' + svgWidth + ' ' + svgHeight"
            style="background-repeat: no-repeat; max-width: 400px"
            [style.background-image]="'url(' + this.parking.parkingLayoutImage + ')'"
            [style.background-size]="'100%'"
        >
            <ng-container *ngIf="bookingAreas">
                <ng-container *ngFor="let area of bookingAreas">
                    <rect
                        (click)="areaClicked(area)"
                        [attr.x]="area.x"
                        [attr.y]="area.y"
                        [attr.width]="area.width"
                        [attr.height]="area.height"
                        class="map-area"
                        (mouseover)="highlightArea($event)"
                        [ngClass]="area.unavailable ? 'unavailable' : ''"
                        (mouseout)="resetArea($event)"
                    ></rect>
                </ng-container>
            </ng-container>
        </svg>
    </div>
</ng-template>
